/**
 * @enum {string}
 */
export const NodeType = {
  FILE: 'blob',
  DIRECTORY: 'tree',
};
